<header class="match-detail__hero sb-card-shell">
  <div class="match-detail__hero-pitch" aria-hidden="true">
    <span class="match-detail__hero-circle"></span>
  </div>

  @if (detail().isOutright) {
    <div class="match-detail__hero-outright">
      <h1 class="match-detail__hero-outright-title">
        {{ detail().outrightLabel }}
      </h1>
      <app-match-detail-date-meta
        [scheduledAt]="detail().scheduledAt"
        [timeLabel]="detail().heroMeta"
      ></app-match-detail-date-meta>
    </div>
  } @else {
    <h1 class="sr-only">{{ detail().homeTeam }} {{ 'matchDetail.vs' | translate }} {{ detail().awayTeam }}</h1>
    <div class="match-detail__hero-row">
      <div class="match-detail__hero-team match-detail__hero-team--home">{{ detail().homeTeam }}</div>

      <div class="match-detail__hero-scoreboard">
        @if (detail().heroBadge) {
          <span class="match-detail__hero-badge">{{ detail().heroBadge }}</span>
        } @else {
          <app-match-detail-date-meta
            [scheduledAt]="detail().scheduledAt"
            [timeLabel]="detail().heroMeta"
          ></app-match-detail-date-meta>
        }

        @if (detail().isLive && detail().scoreLines.length === 2) {
          <div class="match-detail__hero-score">
            <span>{{ detail().scoreLines[0] }}</span>
            <span class="match-detail__hero-score-separator">-</span>
            <span>{{ detail().scoreLines[1] }}</span>
          </div>
        } @else {
          <div class="match-detail__hero-vs">{{ 'matchDetail.vs' | translate }}</div>
        }
      </div>

      <div class="match-detail__hero-team match-detail__hero-team--away">{{ detail().awayTeam }}</div>
    </div>
  }
</header>
